export default "__VITE_ASSET__ChzLtOCG__"